export default "__VITE_ASSET__KU7MOcpA__"